import { createSelector } from 'reselect';
import { generic } from '../../helpers/firebaseTransformations';
import moment from 'moment';
const selectPosts = state => (state.moments.all ? state.moments.all.posts : []);
const selectComments = state => (state.moments.all ? state.moments.all.comments : []);
export const selectActiveMomentId = state => state.ui.activeMoment || [];
const selectMomentsConfig = state => state.moments.config || {};
const selectUserAvatars = state => state.users.avatars;
const selectMomentFilters = state => state.moments.config.imageFilters || {};

export const makePostsArray = createSelector(
    [selectPosts],
    posts => {
        return posts
            ? Object.keys(posts).map(key => {
                  return {
                      ...posts[key],
                      friendlyTimeStamp: moment.unix(posts[key].timestamp).fromNow(),
                      id: key,
                  };
              })
            : [];
    },
);

export const makeMomentWithReadbleTimestamp = createSelector(
    [selectPosts],
    posts => {
        return posts.map(post => {
            post.friendlyTimeStamp = moment.unix(post.timestamp).fromNow();
            return post;
        });
    },
);

export const makeCommentsForPost = createSelector(
    [selectPosts],
    posts => {
        return posts.map(post => {
            post.friendlyTimeStamp = moment.unix(post.timestamp).fromNow();
            return post;
        });
    },
);

export const makeMomentsWithComments = createSelector(
    [makePostsArray, selectComments, selectUserAvatars],
    (posts, comments, userAvatars) => {
        return posts
            .map(post => {
                post.avatar = userAvatars[post.authorId];
                let postComments = comments && comments[post.id] ? comments[post.id] : {};
                let flaggedComments = 0;
                let res = Object.keys(postComments).map(key => {
                    let comment = {...postComments[key]}
                     comment = {...comment, avatar: userAvatars[postComments[key].senderId]}
                    if (comment.flagged) {
                        //add number of comments that have been flagged to post object
                        flaggedComments += Object.keys(postComments[key].flagged).length;
                    }
                    return {
                        ...comment,
                        id: key,
                    };
                });
                post.flaggedComments = flaggedComments;
                post.comments = res;
                return post;
            })
            .sort((a, b) => {
                return b.timestamp - a.timestamp;
            });
    },
);
export const makeMomentFilters = createSelector(
    [selectMomentFilters],
    filters => {
        return filters;
    },
);
export const makeActiveMoment = createSelector(
    [makeMomentsWithComments, selectActiveMomentId],
    (moments, id) => {
        return moments.filter(moment => moment.id === id)[0] || {};
    },
);

export const makeOrderedConfig = createSelector(
    [selectMomentsConfig],
    config => {
        let ordered = [];
        if (config.imageFilters) {
            ordered = generic(config.imageFilters).sort((a, b) => a.index - b.index);
        }

        return {
            ...config,
            imageFilters: ordered,
        };
    },
);
